import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ClienteLogin } from '../../login/cliente_login';
import { ClienteResumen} from '../../login/cliente_login';
import { SessionTokenService } from "../../../components/common/utils/sessionToken.service";
import { HandleError } from "../../../components/common/utils/handleError.component";
import { SegurosContratadosEntity } from "../datosGenerales/entities/seguros_contratados_entity";
import { SegurosContratadoscorporativoService } from "./seguros-contratadoscorporativo.service";
import { correctHeight, detectBody } from "../../../app.helpers";
import { VehiculoEntity } from "../datosGenerales/entities/vehiculo_entity";
import { DatosGeneralesService } from "../datosGenerales/datos-generales.service";
import { ClienteIndividualEntity } from "../datosGenerales/entities/datos_generales_individual_entity";
import { ConsultarUsuarioMasivos } from "../../../components/common/utils/consultarUsuarioMasivos";
import { UtilService } from "../../../components/common/utils/util.service";
import { ModalComponent } from "ng2-bs3-modal/ng2-bs3-modal";
import { ProductosGeneralesEntity } from "../datosGenerales/entities/productos_generales_entity";
import { SessionStorageService, SessionStorage } from "ngx-webstorage";
import { BienSolicitudEntity } from "../datosGenerales/entities/bien_asegurado_entity";
import { CalendarFechaNac } from "../../../components/common/utils/calendarFechaNacParametros";
import { UsuarioLoginEntity } from "../../login/usuario_login_entity";
import { CoberturaBienEntity } from "../datosGenerales/entities/coberturas_entity";




const swal = require("sweetalert2");


declare var jQuery: any;
@Component({
    selector: 'SeguroscorporativosContratados',
    providers: [SegurosContratadoscorporativoService],
    templateUrl: 'seguros-contratadoscorporativo.template.html',
    styleUrls: ["seguros-contratadoscorporativo.style.css"]


})
export class SeguroscorporativosContratados extends CalendarFechaNac implements OnInit {
    usuario: ClienteLogin;
    segurosContratados: SegurosContratadosEntity;
    clienteMasivosIndividual: ClienteIndividualEntity;

    vehiculoReporteSiniestro: VehiculoEntity;


    @ViewChild('coberturas')
    modalCob: ModalComponent;
    renovarVehiculo: boolean;
    rutaCancelacion: boolean;
    rutaRenovacion: boolean;
    renovarOtroRamo: boolean;
    renovarAsistencia: boolean;
    renovarvivienda: boolean;
    cancelarBien: boolean;
    beneficiariosBandera: boolean;
    nuevoDependienteBandera: boolean;
    usuarioLogin: UsuarioLoginEntity;
    usuarioresumen:ClienteResumen;
    reporteVeh: boolean = false;
    reporteViv: boolean = false;

    veh: boolean;
    viv: boolean;
    asi: boolean;
    pro: boolean;
    vid: boolean;

    @SessionStorage("VehiculoSeleccionado")
    public vehiculoSelect;

    coberturasBien: CoberturaBienEntity[];
    deduciblesBien: CoberturaBienEntity[];
    beneficiosBien: CoberturaBienEntity[];
    carenciasBien: CoberturaBienEntity[];
    exclusionesBien: CoberturaBienEntity[];
    clausulasBien: CoberturaBienEntity[];
    aclaratorioBien: CoberturaBienEntity[];
    bandera: boolean;
    cob: boolean;
    ded: boolean;
    ben: boolean;
    car: boolean;
    exc: boolean;
    cla: boolean;
    acl: boolean;

    //0=sin leyenda, 1=solo por renovar, 2=solo por cancelar, 3=por renovar y cancelar
    leyendaVeh: number;
    porRenVeh: number = 0;
    porCanVeh: number = 0;

    leyendaViv: number;
    porRenViv: number = 0;
    porCanViv: number = 0;

    leyendaGrl: number;
    porRenGrl: number = 0;
    porCanGrl: number = 0;

    leyendaAsi: number;
    porRenAsi: number = 0;
    porCanAsi: number = 0;
    urlOrigen: string = "";
    urlAsesor: string = "";
    banderaCita: boolean = false;

    @ViewChild('agendarCita')
    modalAsesor: ModalComponent;

    constructor(private segurosContratadosService: SegurosContratadoscorporativoService,
        public utilsService: UtilService,
        private router: Router,
        private sessionTokenService: SessionTokenService,
        private handleError: HandleError,
        private datosGeneralesIndividualSevice: DatosGeneralesService,
        private consultarMasivo: ConsultarUsuarioMasivos,
        private sesionStorageService: SessionStorageService) {
        super();
        this.renovarVehiculo = false;
        this.renovarOtroRamo = false;
        this.renovarAsistencia = false;
        this.renovarvivienda = false;
        this.cancelarBien = false;
        this.veh = false;
        this.viv = false;
        this.asi = false;
        this.pro = false;
        this.vid = false;
        this.bandera = false;
        this.cob = false;
        this.ded = false;
        this.ben = false;
        this.car = false;
        this.exc = false;
        this.cla = false;
        this.acl = false;
        this.segurosContratados = new SegurosContratadosEntity();
        this.segurosContratados.ProductosGenerales = new Array<ProductosGeneralesEntity>();
        this.segurosContratados.SegurosVehiculo = new Array<VehiculoEntity>();
        this.usuarioresumen=new ClienteResumen();
    }


    ngOnInit(): void {
        try {
            this.coberturasBien = new Array<CoberturaBienEntity>();
            this.deduciblesBien = new Array<CoberturaBienEntity>();
            this.beneficiosBien = new Array<CoberturaBienEntity>();
            this.carenciasBien = new Array<CoberturaBienEntity>();
            this.exclusionesBien = new Array<CoberturaBienEntity>();
            this.clausulasBien = new Array<CoberturaBienEntity>();
            this.aclaratorioBien = new Array<CoberturaBienEntity>();

            /*correctHeight();
            detectBody();*/
            this.usuario=jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
            console.log("this.usuario");
             console.log(this.usuario);
            if (this.usuario == null) {
                let error = { "status": 998, "message": "Acceso denegado" };
                this.handleError.redirectUrl(error)
            } else {
                let bandera = this.sessionTokenService.useJwtHelper();
                this.usuarioresumen = jQuery.parseJSON(this.sesionStorageService.retrieve("usercorporativo"));
                if(this.usuarioresumen==null || this.usuarioresumen==undefined){
                    this.usuarioresumen=this.usuario.Corporativo[0];
                }
                    this.beneficiariosBandera = false;
                    this.segurosContratados = new SegurosContratadosEntity();
                   // this.consultarMasivo.iniciarUsuarioMasivo();
                    console.log(this.usuarioresumen );

                   // this.datosGeneralesIndividualSevice.datosClienteIndividual().subscribe(
                    //     datosClienteIndividual => {
                    //         this.clienteMasivosIndividual = datosClienteIndividual;
                    //         this.sesionStorageService.store("NombreUser", JSON.stringify(this.clienteMasivosIndividual.Nombres + " " + this.clienteMasivosIndividual.ApellidoPaterno + " " + this.clienteMasivosIndividual.ApellidoMaterno));
                    //         sessionStorage.setItem("NombreUser", this.clienteMasivosIndividual.Nombres + " " + this.clienteMasivosIndividual.ApellidoPaterno + " " + this.clienteMasivosIndividual.ApellidoMaterno);
                    //     },
                    //     error => { this.handleError.redirectUrl(error); });

                    this.segurosContratados = new SegurosContratadosEntity();

                    this.segurosContratados.ProductosGenerales = new Array<ProductosGeneralesEntity>();
                    this.segurosContratados.SegurosVehiculo = new Array<VehiculoEntity>();


                    this.segurosContratadosService.consultaSegurosContratados(this.usuarioresumen).subscribe(segurosContratados => {
                        this.segurosContratados=segurosContratados;
                        console.log(segurosContratados.VehiculosCorporativos);
                        console.log(this.segurosContratados);
                     }, error => this.handleError.redirectUrl(error));
                     this.getStyle();

            }
        } catch (ex) {
            this.usuarioLogin = jQuery.parseJSON(sessionStorage.getItem("usuarioLogin"));
            let bandera = this.usuarioLogin.Tipo;
            this.router.navigate(["/login", bandera]);
        }
    }

    cloneSegurosContratados(c: SegurosContratadosEntity) {
        let seguros = new SegurosContratadosEntity();
        for (let prop in c) {
            seguros[prop] = c[prop];
        }
        return seguros;
    }



    getStyle() {

        if (this.segurosContratados.VehiculosCorporativos != null && this.segurosContratados.VehiculosCorporativos.length > 0) {
            this.veh = true;
            console.log("st");
        }
    }

    CargarAsesor(bandera: number) {
      var bandTipoProceso = 7;
      let ban = 0;

      this.utilsService.getUriAsesorVirtual(bandera).subscribe(
        resultUri => {
          this.urlOrigen = resultUri;
          switch (bandera) {
            case 4: //vehiculos corporativo :cliCod/:ciuCod/:uniCod/:OrigenApp/:TipoPersona/:nombreUsuario/:TipoProceso/:Segmento",// corporativo
              this.urlAsesor = this.urlOrigen + this.usuarioresumen.Codigocliente + "/" + this.usuarioresumen.Ciudad + "/"+ this.usuarioresumen.Unidad+ "/1/1/"+this.usuarioresumen.Nombre+"/"+bandTipoProceso+"/1";
              
              break; 
          }
          console.log('uri',this.urlAsesor);
          this.banderaCita = true;
          this.modalAsesor.open();
        }
      );
    }

    CerrarModal() {
      this.banderaCita = false;
      this.urlAsesor = "";
    }


}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/vehiculoscorporativos/seguros-contratadoscorporativo.component.ts